import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { onLogout } = useAuth();
  const navigate = useNavigate(); // Initialize useNavigate

  // Function to handle click event
  const handleLogoClick = () => {
    navigate('/'); // Navigate to home page
  };

  return (
    <nav className="bg-green-500 p-4 flex justify-between items-center">
      <div onClick={handleLogoClick} className="text-white text-xl font-bold bg-transparent border-none cursor-pointer focus:outline-none focus:ring-0">
        Hamroo Dairy Admin
      </div>
      <div>
        <button className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" onClick={onLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
